<template>
    <div>
        <select-modal 
            ref="selectempresa"
            id="empresas"
            titulo-botao="Inserir" 

            titulo-modal="EMPRESA PARTICIPANTE"
            :colunas-modal="colunasModal"
            :metodo-busca="metodoBusca"
            termo-filtro="nomeFantasia"

            titulo-tabela-imutavel="Planejado"
            :colunas-imutaveis="colunas.filter(el => el.key != 'remove')"
            :dados-imutaveis="empresas.planejado"

            titulo-tabela-mutavel="Realizado"
            :colunas-mutaveis="colunas"
            :dados-mutaveis="empresas.realizado"

            coluna-imagem="logoDaEmpresa"
            coluna-tb-imagem="logo"
            :controles="!aprovada && projetoEditavel"   
            
            esconder-selecionados

            @update="atualizarEmpresa"

            :esconder-inserir="!permissao.u"
        >
            <template #btn-remove="data">
                <div>
                    <b-button v-if="projetoEditavel && permissao.d && !aprovada && data.data.item.tipo != 'ExecutoraCriadora' && data.data.item.tipo != 'Proponente' && data.data.item.empresaId != empresaSelecionada.id" variant="flat-danger" class="mr-2"  @click="excluirEmpresa(data.data.item)"><i class="fas fa-trash"></i></b-button>
                </div>
            </template>
        </select-modal>
    </div>
</template>
<script>

import SelectModal from "../componentes/SelectModal";

import EmpresasService from "@/common/services/empresas/empresas.service";

//import cloneDeep from "lodash/cloneDeep";
import helpers from "@/common/utils/helpers";
import { START_LOADING, STOP_LOADING } from "@/store/Store";
import { AlertasMixin } from "@/common/mixins/AlertasMixin";
import ProjetoService from "@/common/services/projeto/projeto.service";
import PropostaService from "@/common/services/proposta/proposta.service";

export default {
    name: "ProjetoEmpresas",
    emits: ["update"],
    mixins: [AlertasMixin],
    props: {
        tela : {
            type : String
        },
        projetoId: {
            type: String,
            required: true
        },
        projetoIdBase: {
            type: String,
            required: true
        },
        aprovada: {
            type: Boolean,
            default: false
        },
        propostaIdBase: {
            type: String,
            required: true
        },
        projetoEditavel : {
            type : Boolean,
            default : false
        }
    },
    components: {
        SelectModal
    },
    data: () =>({
        objeto : {
            'empresas-cooperadas' : {
                accordion : 'empresas-cooperadas',
                tipo : 'Proponente',
                remover : 'Cooperada'
            },
            'empresas-executoras' : {
                accordion : 'empresas-executoras',
                tipo : 'Executora',
                remover : 'Executora',
            }
        },
        colunasModal : [
            { key: "acoes", label: "Ações", tdClass: "acoes", },
            { key: "logoDaEmpresa", label:""},
            { key: "nomeFantasia", label: "Empresa", },
            { key: "tipo", label: "Tipo", },
            { key: "email", label: "E-mail", },  
            { key: "endereco.cidade", label: "Cidade", },  
            { key: "endereco.uf", label: "UF", },  
            { key: "actions", label: "Ações", tdClass: "acoes", },
        ],
        colunas : [
            { key: "logo", label:""},
            { key: "nomeFantasia", label: "Empresa", formatter : (a,b,c) => {
                return c.nomeFantasia || c.razaoSocial
            } },            
            { key: "tipo", label: "Tipo",
                formatter: (value) => {
                    if (value) return helpers.getEnum(value).text;
                },
            },
            { key: "custosProprios", label: "Custos próprios(R$)",
                formatter: (v) => {
                    if(v != null) return helpers.formatarValor(v);
                }
            }, 
            { key: "repasseExecutoras", label: "Repasse executoras(R$)",
                formatter: (v) => {
                    if(v != null) return helpers.formatarValor(v);
                }
            }, 
            { key: "valorInvestido", label: "Valor do investimento(R$)",
                formatter: (v) => {
                    if(v != null) return helpers.formatarValor(v);
                }
            }, 
            { key: "remove", label: "Ações", },
        ],
        empresas : {
            planejado : [],
            realizado : [],
        },
    }),
    methods:{
        metodoBusca: function(){
            return new Promise((resolve, reject) => { 
                EmpresasService.buscarTipo('').then(res => {
                    let resultado = {
                        data : {
                            data : res.data.data.filter(
                                el => 
                                    el.id != this.empresaSelecionada.id 
                                    //&& el.tipo == this.objeto[this.tela].tipo
                                    && this.empresas.realizado.find(el2 => el2.empresaId == el.id) == undefined
                                ).map(el => {
                                    el.tipo = el.tipo == 'Proponente' ? 'Cooperada' : el.tipo;
                                    el.nomeFantasia = el.nomeFantasia || el.razaoSocial;
                                    return el;
                                })
                        }
                    };
                    resolve(resultado);
                }).catch(err => {
                    reject(err);
                });
            });
        },
        atualizarEmpresa: function(empresa){

            let form = {
                projetoId: this.projetoIdBase,
                empresasId: [empresa.item.id]
            };

            this.$store.dispatch(START_LOADING);
            ProjetoService.salvarEmpresas(empresa.item.tipo == 'Executora' ? 'executoras' : 'cooperadas',form).then(() => {
                this.toast("Empresas atualizadas com sucesso!",{
                    variant: "success",
                });
                this.buscarEmpresas().then(() => {
                    this.$refs['selectempresa'].recarregar();
                });
            }).catch(() => {
                this.toast("Ocorreu um erro ao atualizar as empresas",{
                    variant: "danger",
                });
            }).finally(() => {
                this.$store.dispatch(STOP_LOADING);
            });
        },
        excluirEmpresa: function(empresa){

            let form = {
                projetoId: this.projetoIdBase,
                empresasId: [empresa.id]
            };
            this.confirmar("Deseja remover essa empresa do projeto?").then(confirmado => {
                if(!confirmado) return;
                this.$store.dispatch(START_LOADING);
                ProjetoService.removerEmpresa(empresa.tipo == 'Executora' ? 'executoras' : 'cooperadas',form).then(() => {
                    this.alertaSucesso("Empresa removida com sucesso!");
                    this.buscarEmpresas();
                }).catch(() => {
                    this.alertaErro("Ocorreu um erro ao remover a empresa");
                }).finally(() => {
                    this.$store.dispatch(STOP_LOADING);
                });
            });
        },
        buscarEmpresas : function(){
            return new Promise((resolve) => {
                this.$store.dispatch(START_LOADING);
                ProjetoService.buscarEmpresas(this.projetoIdBase).then(res => {
                    this.empresas.realizado = res.data.data;
                    resolve();
                }).finally(() => {
                    this.$store.dispatch(STOP_LOADING);
                });
            });
            
        },
        buscarEmpresasProposta : function(){
            return new Promise((resolve, reject) => {
                PropostaService.buscarEmpresas(this.propostaIdBase).then(res => {
                    this.empresas.planejado = res.data.data;
                    resolve();
                }).catch(err => {
                    reject(err);
                });
            });
        },
        montar : function(){
            this.buscarEmpresas();
            this.buscarEmpresasProposta();
        }
    },
    mounted(){
    },
    computed: {
        empresaSelecionada() {
            return this.$store.state.app.selectedCompanyObj;
        },
        permissao() {
            return this.$store.getters['app/retornaPermissao']('ProjetosPdEmpresas');
        },
    }
}
</script>
<style>
    
</style>